import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export interface TherapistSummary {
  id: string;
  displayName: string;
  bio: string;
  gender: string;
  hourlyRateNgn: number;
  couplesHourlyRateNgn: number | null;
  yearsExperience: number;
  responseTimeHours: number;
  ratingAvg: number;
  ratingCount: number;
  specializations: string[];
  languages: string[];
  faithAffiliation?: string;
  status: string;
  profilePhotoUrl?: string | null;
}

export interface TherapistFilters {
  specialization: string;
  gender: string;
  language: string;
  faithAffiliation: string;
  priceMax: string;
  cursor: string;
  search: string;
}

export function useTherapists(filters: TherapistFilters) {
  return useQuery({
    queryKey: ['therapists', filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters.specialization) params.set('specialization', filters.specialization);
      if (filters.gender) params.set('gender', filters.gender);
      if (filters.language) params.set('language', filters.language);
      if (filters.faithAffiliation) params.set('faithAffiliation', filters.faithAffiliation);
      if (filters.priceMax) params.set('priceMax', filters.priceMax);
      if (filters.cursor) params.set('cursor', filters.cursor);
      if (filters.search.trim()) params.set('search', filters.search.trim());
      params.set('limit', '12');

      return api.get<{ data: TherapistSummary[]; nextCursor: string | null }>(
        `/therapists?${params.toString()}`
      );
    },
  });
}
